

import { App } from "vue";
import { Path } from "vue-i18n";
import Localization from "./localization";
import { LocalizationInfo ,LanguageInfo } from "./types";

const localization = new Localization();

export function localizer(key: Path, namedParameters: Record<string, unknown>|undefined = undefined): string{
  return localization.localizer(key, namedParameters);
}

export { LanguageInfo,  localization as localization };

export default {
  install(app: App, localizationInfo: LocalizationInfo) {
   
    localization.use(app, localizationInfo);
  },
};

